import Precisions from './precisions';
import AdresseEmployeur from './adresseEmployeur';
import PrecisionsState from './types';
import { MutationTree, Module, ActionTree, GetterTree } from 'vuex';
import { RootState } from '@/store/types';

const namespaced: boolean = true;

export const state: PrecisionsState = {
	precisions: new Precisions(),
	adresseEmployeur: new AdresseEmployeur()
};

export const mutations: MutationTree<PrecisionsState> = {
	mutatePrecisions(state: PrecisionsState, precisions: Precisions): void {
		state.precisions = Object.assign({}, precisions);
	},
	mutateAdresseEmployeur(state: PrecisionsState, adresseEmployeur: AdresseEmployeur): void {
		state.adresseEmployeur = Object.assign({}, adresseEmployeur);
	}
};

export const actions: ActionTree<PrecisionsState, RootState> = {
	updatePrecisions(state, precisions: Precisions): void {
		state.commit('mutatePrecisions', precisions);
	},
	updateAdresseEmployeur(state, adresseEmployeur: AdresseEmployeur): void {
		state.commit('mutateAdresseEmployeur', adresseEmployeur);
	}
};

export const getters: GetterTree<PrecisionsState, RootState> = {
	getPrecisions(state) {
		return state.precisions;
	},
	getAdresseEmployeur(state) {
		return state.adresseEmployeur;
	}
};

export const precisions: Module<PrecisionsState, RootState> = {
	namespaced,
	state,
	getters,
	actions,
	mutations
};
